'use client';

import { css } from '@bts-web/utils-style-engine';
import { TradeOptionButton, TradeOptionButtonProps } from './TradeOptionButton';

const tradeOptionGroupContainer = css({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
});

const tradeOptionGroupLabelStyles = css({
  fontSize: 'label.medium_bold',
  fontWeight: 'label.medium_bold',
  lineHeight: 'label.medium_bold',
  letterSpacing: 'label.medium_bold',
  width: '100%',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  px: 'medium',
  pt: 'medium',
  pb: 'extra_small_2',
});

export type TradeOptionsItems = TradeOptionButtonProps & {
  testId: string;
};

interface TradeOptionGroupProps {
  label: string;
  items: TradeOptionsItems[];
}

export const TradeOptionGroup = ({ label, items }: TradeOptionGroupProps) => (
  <div className={tradeOptionGroupContainer}>
    {label && <div className={tradeOptionGroupLabelStyles}>{label}</div>}
    <div className={tradeOptionGroupContainer}>
      {items.map(
        ({ testId, title, subtitle, icon, tag, disabled, onClick }) => {
          const disabledProps = disabled === true ? { disabled } : {};

          return (
            <TradeOptionButton
              key={testId}
              dataTestId={testId}
              title={title}
              subtitle={subtitle}
              icon={icon}
              tag={tag}
              onClick={onClick}
              {...disabledProps}
            />
          );
        },
      )}
    </div>
  </div>
);
